export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5313.33f651de.jpg";